import { createContext, useContext, type ReactNode } from 'react';
import type { IdentityResponse } from './identityApi';

type IdentityContextValue = { identity: IdentityResponse; refreshIdentity: () => Promise<void>; signOut: () => Promise<void> };
const Context = createContext<IdentityContextValue | null>(null);
export function IdentityProvider({ value, children }: { value: IdentityContextValue; children: ReactNode }) { return <Context.Provider value={value}>{children}</Context.Provider>; }
export function useIdentity() { const value = useContext(Context); if (!value) throw new Error('IdentityProvider is required.'); return value; }
